import React from 'react';
import Vendorrouter from './Vendorrouter';
import Userrouter from './Userrouter';
import { useCart } from './CartProvider';
import { jwtDecode } from 'jwt-decode';

function MainNavigation() {
    let { role } = useCart();
    
    if (!role) {
        const token = localStorage.getItem('authToken');
        
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                role = decodedToken?.role;
            } catch (error) {
                console.error('Invalid token:', error);
            }
        }
    }
    return (
        <div>
            {
                role === 'vendor' ? (
                    <Vendorrouter />
                ) : (
                    <Userrouter/>
                )
            }  

        </div>
    );
}

export default MainNavigation;
